import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/BaseForm.css';
import titre from '../img/Title.png';
import fr from '../locales/fr';
import en from '../locales/en';

function Room({ ws }) {
  const [pin, setPin] = useState('');
  const [pseudo, setPseudo] = useState('');
  const [pinError, setPinError] = useState('');
  const [pseudoError, setPseudoError] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const navigate = useNavigate();

  const [borderColorPinClass, setPinBorderColor] = useState('champsformgreen');
  const [borderColorPseudoClass, setPseudoBorderColor] = useState('champsformgreen');
  const [showPopup, setShowPopup] = useState(true);
  const [hasAccepted, setHasAccepted] = useState(false);
  const [currentPage, setCurrentPage] = useState(0); // 0 = Terms, 1 = Privacy
  const [termsScrolled, setTermsScrolled] = useState(false);
  const [privacyScrolled, setPrivacyScrolled] = useState(false);

  const termsScrollRef = useRef(null);
  const privacyScrollRef = useRef(null);

  const translations = language === 'fr' ? fr : en;

  useEffect(() => {
    const accepted = localStorage.getItem('termsAccepted');
    if (accepted === 'true') {
      setShowPopup(false);
      setHasAccepted(true);
    }
  }, []);

  const handleScroll = (e) => {
    const element = e.target;
    const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;

    if (isAtBottom) {
      if (currentPage === 0) {
        setTermsScrolled(true);
      } else {
        setPrivacyScrolled(true);
      }
    }
  };

  const handleNextPage = () => {
    setCurrentPage(1);
    setPrivacyScrolled(false); // Reset scroll state for privacy page
    // Reset scroll position to top when moving to privacy page
    setTimeout(() => {
      if (privacyScrollRef.current) {
        privacyScrollRef.current.scrollTop = 0;
      }
    }, 0);
  };

  const handleBackPage = () => {
    setCurrentPage(0);
    // Reset scroll position to top when going back to terms page
    setTimeout(() => {
      if (termsScrollRef.current) {
        termsScrollRef.current.scrollTop = 0;
      }
    }, 0);
  };

  const handleAcceptTerms = () => {
    localStorage.setItem('termsAccepted', 'true');
    setShowPopup(false);
    setHasAccepted(true);
  };

  const handlePinChange = (e) => {
    let value = e.target.value.toUpperCase(); // Convertir en majuscules
    const alphanumericRegex = /^[a-zA-Z0-9]*$/; // Expression régulière pour vérifier l'alphanumérique

    // Limiter la longueur du PIN à 4 caractères
    if (value.length > 4) {
      value = value.slice(0, 4);
    }

    if (!alphanumericRegex.test(value)) {
      setPinError(translations.room.pinAlphanumericError);
      setPinBorderColor('champsformred');

    } else if (value.length !== 4) {
      setPinError(translations.room.pinLengthError);
      setPinBorderColor('champsformred');
    } else {
      setPinError('');
      setPinBorderColor('champsformgreen');
    }
    setPin(value);
  };

  const handlePseudoChange = (e) => {
    const value = e.target.value;
    /*const lettersRegex = /^[a-zA-Z]*$/; // Expression régulière pour vérifier les lettres uniquement

    if (!lettersRegex.test(value)) {
      setPseudoError('Le pseudo doit contenir uniquement des lettres.');
      setPseudoBorderColor('champsformred');
    } else*/
     if (!value.trim()) {
      setPseudoError(translations.room.pseudoRequiredError);
      setPseudoBorderColor('champsformred');
     }
    else if (value.length > 16){
      value = value.slice(0, 4);
      setPinError(translations.room.pseudoLengthError);
      setPinBorderColor('champsformred');
    } else {
      setPseudoError('');
      setPseudoBorderColor('champsformgreen');
    }
    setPseudo(value);
  };

  const handleColorChange = (e) => {
    setSelectedColor(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    localStorage.setItem('pseudo', pseudo);

    if (!pin || !pseudo || !ws || pin.length !== 4 || !pseudo.trim()) {
      console.error('PIN, pseudo ou connexion WebSocket manquants.');
      return;
    }

    try {
      const ROOM = "UNITY" + pin;
      ws.send(ROOM + ":CHECK");

      ws.onmessage = function (event) {
        var message = event.data;
        console.log(message)
        if (message === ROOM + ":YES") {
          localStorage.setItem('UNITY', ROOM);
          localStorage.setItem('pseudoColor', selectedColor);
          ws.onmessage = null;
          // Autorisation de navigation
          sessionStorage.setItem("canAccessMediaSelect", "true");

          navigate("/mediaSelect", {
            state: { fromAuthorized: true }
          });
        }
      };

    } catch (error) {
      console.error('Erreur lors de l\'envoi des données via WebSocket :', error);
    }

  };

  const isButtonDisabled = !pin || !pseudo || pin.length !== 4 || !pseudo.trim() || !selectedColor;

  return (
    <div className='boxform'>
      {showPopup && (
        <div className='popup-overlay'>
          <div className='popup-content'>
            <h2>{translations.popup.title}</h2>
            <p className='popup-intro-message'>{translations.popup.message}</p>
            <p className='popup-page-indicator'>{currentPage === 0 ? '1/2' : '2/2'}</p>

            {currentPage === 0 ? (
              <div className='popup-document-single'>
                <h3>{translations.popup.termsTitle}</h3>
                <div className='popup-scroll-box' onScroll={handleScroll} ref={termsScrollRef}>
                  {translations.popup.termsContent.split('\n').map((line, index) => (
                    <p key={`terms-${index}`}>{line}</p>
                  ))}
                </div>
                <button
                  className='popup-accept-button'
                  onClick={handleNextPage}
                  disabled={!termsScrolled}
                >
                  {translations.popup.nextButton}
                </button>
              </div>
            ) : (
              <div className='popup-document-single'>
                <h3>{translations.popup.privacyTitle}</h3>
                <div className='popup-scroll-box' onScroll={handleScroll} ref={privacyScrollRef}>
                  {translations.popup.privacyContent.split('\n').map((line, index) => (
                    <p key={`privacy-${index}`}>{line}</p>
                  ))}
                </div>
                <div className='popup-buttons'>
                  <button className='popup-back-button' onClick={handleBackPage}>
                    {translations.popup.backButton}
                  </button>
                  <button
                    className='popup-accept-button'
                    onClick={handleAcceptTerms}
                    disabled={!privacyScrolled}
                  >
                    {translations.popup.acceptButton}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <img className='titreimage' src={titre} alt='titre'></img>
      <form onSubmit={handleSubmit}>
        <label>
          <div className='labelform'>
            <h2>{translations.room.roomNumber}</h2>
            <input className={`champsformpin ${borderColorPinClass}`} type="text" value={pin} maxLength="4" onChange={handlePinChange} placeholder={translations.room.pinPlaceholder} required />
            {pinError && <span className="error-message">{pinError}</span>}
            <h2>{translations.room.pseudo}</h2>
            <input className={`champsformpseudo ${borderColorPseudoClass}`} type="text" value={pseudo} maxLength="16" onChange={handlePseudoChange} placeholder={translations.room.pseudoPlaceholder} required />
            {pseudoError && <span className="error-message">{pseudoError}</span>}
            <h2>{translations.room.pseudoColor}</h2>
          </div>
          <div className='boxformcouleur'>
            <label className={`radiobuttonbleu ${selectedColor === "BLUE" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="BLUE"
                checked={selectedColor === 'BLUE'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttonrouge ${selectedColor === "RED" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="RED"
                checked={selectedColor === 'RED'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttonblanc ${selectedColor === "WHITE" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="WHITE"
                checked={selectedColor === 'WHITE'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttonnoir ${selectedColor === "BLACK" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="BLACK"
                checked={selectedColor === 'BLACK'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttoncyan ${selectedColor === "CYAN" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="CYAN"
                checked={selectedColor === 'CYAN'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttongris ${selectedColor === "GRAY" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="GRAY"
                checked={selectedColor === 'GRAY'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttonvert ${selectedColor === "GREEN" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="GREEN"
                checked={selectedColor === 'GREEN'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttonmagenta ${selectedColor === "MAGENTA" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="MAGENTA"
                checked={selectedColor === 'MAGENTA'}
                onChange={handleColorChange} />
            </label>
            <br />
            <label className={`radiobuttonjaune ${selectedColor === "YELLOW" ? "select" : ""}`}>
              <input
                className="hidden-radio"
                type="radio"
                name="color"
                value="YELLOW"
                checked={selectedColor === 'YELLOW'}
                onChange={handleColorChange} />
            </label>
          </div>
          <br />
          <br />
        </label>
        <div className='flexbuttonconnexion'>
          <button className='buttonconnexion' type="submit" disabled={isButtonDisabled}>{translations.room.connection}</button>
        </div>
      </form>
      <br />
      <div className='footer-links'>
        <a href="https://studiopimbina.ca/en/terms-of-service-unfriend/" target="_blank" rel="noopener noreferrer">
          {translations.footer.termsOfService}
        </a>
        <span> | </span>
        <a href="https://studiopimbina.ca/en/privacy-unfriend/" target="_blank" rel="noopener noreferrer">
          {translations.footer.privacyPolicy}
        </a>
      </div>
    </div>
  );
}

export default Room;
